'use client';

import React from 'react';
import Link from 'next/link';
import Nav from '@/components/layout-new/builder/Nav';
import Logout from './Logout';
import Logo from '@/components/layout-new/Logo';
import { CANDIDATES_ME_ROUTER_PATH } from '@/constants/router-path';
import { HEADER_ID } from '@/constants/component-id';

const Header = (props: {
  bgColor?: string;
  backProps?: { title: string; link: string };
  showNav?: boolean;
  showLogo?: boolean;
  style?: React.CSSProperties;
  isHideHeader?: boolean;
}) => {
  const {
    bgColor = 'bg-white',
    backProps,
    showNav = false,
    showLogo = false,
    style,
    isHideHeader,
  } = props;

  return (
    <header
      id={HEADER_ID}
      className={`fixed top-0 left-0 right-0 h-16 min-w-[375px] ${isHideHeader ? 'hidden' : 'flex'} justify-between items-center whitespace-nowrap pr-5 z-[1100] ${showNav ? bgColor : `${bgColor} tablet:bg-transparent`} bg-opacity-80 backdrop-blur ${showNav ? 'pl-16' : 'pl-5 tablet:pl-[97px]'} tablet:pr-0`}
      style={style}
    >
      {backProps ? (
        <Link
          className="px-5 py-2 rounded-full bg-slate-100 text-sm leading-5.5 font-semibold"
          href={backProps?.link}
        >
          {backProps?.title}
        </Link>
      ) : (
        <>
          {showLogo && (
            <Logo href={CANDIDATES_ME_ROUTER_PATH} className="tablet:hidden" />
          )}
          <div />
        </>
      )}
      <div className="tablet:w-[1200px] tablet:mx-auto tablet:pr-5 flex justify-end">
        <Logout />
      </div>
      {showNav && (
        <div className="absolute left-5">
          <Nav />
        </div>
      )}
    </header>
  );
};

export default Header;
